import React, { useMemo, useState } from "react";
import { Card } from "@ui/card";
import { Separator } from "@ui/separator";
import DeleteAccountDialog from "./dialogs/DeleteAccountDialog";
import DeleteReasonsDialog from "./dialogs/DeleteReasonsDialog";
import ConfirmDeleteAccountDialog from "./dialogs/ConfirmDeleteAccountDialog";
import RemoveAccountDialog from "./dialogs/RemoveAccountDialog";
import { useAppSelector } from "@lib/stores";
import SettingsRow from "./components/SettingRow";
import LinkedAccounts from "./components/LinkedAccounts";
import ChangeNameRow from "./components/ChangeNameRow";
import ChangePhoneRow from "./components/ChangePhoneRow";
import ChangeEmailRow from "./components/ChangeEmailRow";
import ChangePasswordRow from "./components/ChangePasswordRow";

export type EmailInput = {
  email: string;
};

const AccountSettingsTab = () => {
  const user = useAppSelector((state) => state.auth.user);
  const updateUserNameStatus = useAppSelector(
    (state) => state.auth.updateUserNameStatus
  );
  const updateEmailStatus = useAppSelector(
    (state) => state.auth.updateEmailStatus
  );
  const changMyPasswordStatus = useAppSelector(
    (state) => state.auth.changMyPasswordStatus
  );
  const setMyEmailPasswordStatus = useAppSelector(
    (state) => state.auth.setMyEmailPasswordStatus
  );

  const loading = useMemo(() => {
    return (
      updateUserNameStatus === "loading" ||
      updateEmailStatus === "loading" ||
      changMyPasswordStatus === "loading" ||
      setMyEmailPasswordStatus === "loading"
    );
  }, [
    updateUserNameStatus,
    changMyPasswordStatus,
    setMyEmailPasswordStatus,
    updateEmailStatus,
  ]);

  const [dialogStates, setDialogStates] = useState<{
    reasons: boolean;
    confirmDelete: boolean;
    removeAccount: boolean;
  }>({
    reasons: false,
    confirmDelete: false,
    removeAccount: false,
  });

  return (
    <div className="mb-20 flex w-full items-center justify-center py-8">
      {/* Dialogs */}
      <DeleteReasonsDialog
        openDialog={dialogStates.reasons}
        setOpenDialog={(state) =>
          setDialogStates((prev) => ({ ...prev, reasons: state }))
        }
        setOpenConfirmDeleteAccountDialog={(state) =>
          setDialogStates((prev) => ({ ...prev, confirmDelete: state }))
        }
      />
      <ConfirmDeleteAccountDialog
        openDialog={dialogStates.confirmDelete}
        setOpenDialog={(state) =>
          setDialogStates((prev) => ({ ...prev, confirmDelete: state }))
        }
        setOpenRemoveAccountDialog={(state) =>
          setDialogStates((prev) => ({ ...prev, removeAccount: state }))
        }
      />
      <RemoveAccountDialog
        openDialog={dialogStates.removeAccount}
        setOpenDialog={(state) =>
          setDialogStates((prev) => ({ ...prev, removeAccount: state }))
        }
      />
      <Card
        className={`w-full border-none bg-[#D9D9D926]/15 px-4 sm:w-[580px] ${
          loading && "opacity-25"
        }`}
      >
        <ChangeNameRow user={user} />
        <Separator className="bg-[#0000001A] dark:bg-[#D9D9D9]/15" />
        <ChangePhoneRow user={user} />
        <Separator className="bg-[#0000001A] dark:bg-[#D9D9D9]/15" />
        <ChangeEmailRow user={user} />
        <Separator className="bg-[#0000001A] dark:bg-[#D9D9D9]/15" />
        <LinkedAccounts />
        <Separator className="bg-[#0000001A] dark:bg-[#D9D9D9]/15" />
        <ChangePasswordRow user={user} />
        <Separator className="bg-[#0000001A] dark:bg-[#D9D9D9]/15" />
        <SettingsRow label="delete account">
          <>
            <div></div>
            <DeleteAccountDialog
              setOpenDialog={(state) =>
                setDialogStates((prev) => ({ ...prev, reasons: state }))
              }
            />
          </>
        </SettingsRow>
      </Card>
    </div>
  );
};

export default AccountSettingsTab;
